import _asyncToGenerator from "@babel/runtime/helpers/asyncToGenerator";
import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _regeneratorRuntime from "@babel/runtime/regenerator";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import Pagelife from "../../lego-pagelife";
import { getQuery, getPageIdInfo, isAndroid } from "../../utils/common";
import { getWebViewRefParams } from "../../utils/setWebViewPageId";
import lego from "../../lego";
import { getWinMeasurementPerfData } from "../../lego-perf/core/jobs/base";
var sendData = function sendData(obj) {
  lego.send(obj);
};
// 将缓存变量放在 window 对象上
if (!window.cachedWebViewRefParams) {
  window.cachedWebViewRefParams = null;
}
var initPvLister = function initPvLister(params, legoInit) {
  var pageIdInfo = getPageIdInfo();
  if (!pageIdInfo || !pageIdInfo.pageId) {
    return;
  }
  // 初始化上一个页面的信息
  var referrerObj = {
    refpagetype: '',
    refpagequery: '',
    refsubpageID: '',
    refsectionId: '',
    refsortId: ''
  };

  // 处理数据并发送
  var processAndSendData = function processAndSendData() {
    // 从url里面获取
    var refpagequery = getQuery('refpagequery');
    var refsubpageID = getQuery('refsubpageID');
    refpagequery && (referrerObj.refpagequery = refpagequery);
    refsubpageID && (referrerObj.refsubpageID = refsubpageID);
    var userBackup = {};
    if (legoInit) {
      userBackup = legoInit.getUserBackup() || {};
    }
    var PVPagetype = 'zpmshow';
    if (params.pagetype || userBackup.pagetype || pageIdInfo.isDetailPage) {
      PVPagetype = 'CommodityDetail';
    }
    sendData({
      pagetype: PVPagetype,
      actiontype: pageIdInfo === null || pageIdInfo === void 0 ? void 0 : pageIdInfo.pageId,
      backup: _objectSpread(_objectSpread(_objectSpread({}, userBackup), referrerObj), {}, {
        h5pageLoadingTime: getWinMeasurementPerfData('h5pageLoadingTime'),
        h5pageLoadedTime: getWinMeasurementPerfData('h5pageLoadedTime')
      })
    });
  };

  // 如果缓存已经存在，直接使用缓存的数据
  if (window.cachedWebViewRefParams) {
    referrerObj = window.cachedWebViewRefParams;
    processAndSendData(); // 处理并发送数据
  }
};
var autoPvLister = /*#__PURE__*/function () {
  var _ref = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(params, legoInit) {
    var result;
    return _regeneratorRuntime.wrap(function _callee$(_context) {
      while (1) switch (_context.prev = _context.next) {
        case 0:
          _context.prev = 0;
          _context.next = 3;
          return getWebViewRefParams();
        case 3:
          result = _context.sent;
          window.cachedWebViewRefParams = {
            refpagetype: result.refpagetype || '',
            refpagequery: result.refpagequery || '',
            refsubpageID: result.refsubpageID || '',
            refsectionId: result.refsectionId || '',
            refsortId: result.refsortId || ''
          };
          // 初始化 PV 监听器
          if (window.location.href.indexOf('appTabShow') > -1 && isAndroid()) {
            Pagelife.add('onShow', function () {
              return initPvLister(params, legoInit);
            });
          } else {
            initPvLister(params, legoInit);
            // 如果是转转的客户端
            Pagelife.add('onShow', function () {
              return initPvLister(params, legoInit);
            });
          }
          try {
            window['ZZ_LEGO_ZPMSHOW_FUNS'] = function () {
              return initPvLister(params, legoInit);
            };
          } catch (error) {
            console.error('Failed to set ZZ_LEGO_ZPMSHOW_FUNS:', error);
          }
          _context.next = 12;
          break;
        case 9:
          _context.prev = 9;
          _context.t0 = _context["catch"](0);
          initPvLister(params, legoInit);
        case 12:
        case "end":
          return _context.stop();
      }
    }, _callee, null, [[0, 9]]);
  }));
  return function autoPvLister(_x, _x2) {
    return _ref.apply(this, arguments);
  };
}();
export default autoPvLister;